import { MigrationDefinition } from '@luzula/luzula-lib';

import { migrationV_1ToV0 } from './migration-v-1-to-v0';
import { migrationV0ToV1 } from './migration-v0-to-v1';
import { migrationV1ToV2 } from './migration-v1-to-v2';
import { migrationV2ToV3 } from './migration-v2-to-v3';
import { migrationV3ToV4 } from './migration-v3-to-v4';
import { migrationV4ToV5 } from './migration-v4-to-v5';
import { migrationV5ToV6 } from './migration-v5-to-v6';
import { migrationV6ToV7 } from './migration-v6-to-v7';

/** Alle Bohrpunkt-Migrationen */
export const ALL_MIGRATIONS: MigrationDefinition[] = [
  migrationV_1ToV0,
  migrationV0ToV1,
  migrationV1ToV2,
  migrationV2ToV3,
  migrationV3ToV4,
  migrationV4ToV5,
  migrationV5ToV6,
  migrationV6ToV7
];
